import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		appclass: 'page-home',
		indepth: 1,
		projects: [
			{
				name: 'Western Waters',
				build: 'Wordpress'
			},
			{
				name: 'Hinman Engineers',
				build: 'Wordpress'
			}
		]
	},
	mutations: {
		APP_CLASS: (state, payload) => {
			state.appclass = payload;
		},
		ADD_PROJECT: (state, payload) => {
			state.projects.push(payload);
		},
		REMOVE_PROJECT: (state, index) => {
			state.projects.splice(index, 1);
		},
		REMOVE_INDEPTH: (state) => {
			state.indepth = 0;
		}
	},
	actions: {
		removeProject: (context, index) => {
			context.commit('REMOVE_PROJECT', index);
		}
	},
	getters: {
		getProjects: state => {
			return state.projects;
		},
		getProjectCount: state =>  {
			return state.projects.length;
		}
	}
});
